/* eslint-disable no-unused-vars */
/**
 * @author 肖阳
 * @time 2020-9-10
 * @dec 各种节点类
 */
import { HashCode } from "../../utils";
import { getFormFieldList } from "@/CommonDP/components/processComponents/config";
export class Node {
  nodeId;
  type;
  childNode;
  title = "";
  content = "content";
  conditional="";
  nodeKey = "";
  conditionNodes;
  flowNodeDefinitionPermissionPos;
  constructor({ id, type, row }) {
    if (type === "2") {
      this.title = "节点";
    }
    this.nodeKey = "";
    this.groupId = id;
    this.id = HashCode();
    this.type = type;
    this.content = "";
    this.row = row;
    this.flowNodeDefinitionPermissionPos = [];
  }
}
export class ConditionNode {
  title = "默认条件";
  conditional=""
  conditionRank;
  data = {};
  constructor({ groupId, type, id, row }) {
    this.id = HashCode();
    this.groupId = groupId;
    this.type = type;
    this.content = "";
    this.conditional = "";
    this.groupPid = id;
    this.row = row;
    this.nodeKey = "";
  }
}
export class RowNode extends Node {
  data = {
    assigneeList: [], // 审批 用户/项目角色
    assigneeSelectionStrategy: "0", // 审批人设置(0:指定成员 1:申请人本人 2:申请人自选)
    runtimeSelectUsers: 0, // 是否在审批时才决定处理人(0/1)
    ccList: [], // 抄送人
    ccOneself: 0, // 是否抄送给申请人本人. 0/1
    ccOptional: 1, //  抄送人设置 : 是否允许申请人选择抄送人。 0/1
    multiUserDealStrategy: 2, // 审批人设置 1：或签 2：会签 3：依次审批
    allowAddNode: 0, // 是否允许加签（0/1）
    canChangeAssignee: 0, // 是否可变更审批人0/1
    timeoutHandleEnable: 0, // 启用超时处理 0否/1是
    timeoutHandleStrategy: 0, // 超时处理策略；0：自动通过，1：指定处理人，2：自动驳回，3：不处理
    formFieldPermissionList: getFormFieldList() || [] // 表单字段权限列表
  };
  constructor({ id, type, row, title }) {
    super({ id, type, row, title });
  }
}
export class CopyNode {
  title = "条件分支";
  id = HashCode();
  content = "";
  conditionRank;
  data = {};
  constructor({ id, childNode, ...node }) {
    this.conditionRank = node.conditionRank + 1;
    this.nodeKey = "";
    return Object.assign(node, this);
  }
}
